import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	standardEdition: {
		id: 'recommend-standard-over-premium.standard-edition-column.standard-edition',
		description: 'Label for Standard edition plan',
		defaultMessage: 'Standard',
	},
	whiteboardsLimited: {
		id: 'recommend-standard-over-premium.standard-edition-column.whiteboards-limited',
		description: 'Label indicating whiteboards feature is limited in Standard edition',
		defaultMessage: 'Limited',
	},
});
